import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ThemesServiceV2 } from '@core/themes/themes.service';
import { environment } from 'environments/environment';

import { LoginService } from '../pages/login/login.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class AuthguardService implements CanActivate {
  constructor(private router: Router, private loginsvc: LoginService, private themeServiceV2: ThemesServiceV2) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean  {
    const currentUser = JSON.parse(localStorage.getItem('currentuser')),
      qparams = Object.assign({}, next.queryParams);
    let xStringCallBackUrl: string;
    let xString: string,
      xStringMatch = true;
    if (qparams) {
      xString = qparams.xString;
      xStringCallBackUrl = qparams.state;
      if (xStringCallBackUrl) {
        xString = xStringCallBackUrl;
      }
      if (currentUser && xString) {
        xStringMatch = xString.toString() == currentUser.xString.toString();
      }
      if (qparams.next && qparams.next.indexOf(environment.loginRoute) > -1) {
        delete qparams.next;
      }
    }
    if (this.loginsvc.isLoggedIn() && xStringMatch) {
      return true;
    } else if (xString) {
      return this.loginsvc.xstringLogin(xString).pipe(map(data => {
          if (data.IsSuccess) {
            if (state.url) {
              this.themeServiceV2.initTheme();
              if (state.url.indexOf(environment.loginRoute) > -1) {
                // avoid looping
                this.router.navigate([environment.defaultRouteAfterLogin], {
                  queryParams: qparams,
                });
              } else {
                this.router.navigateByUrl(state.url);
              }
            } else {
              this.router.navigate([environment.defaultRouteAfterLogin], {
                queryParams: qparams,
              });
            }
            return true;
          } else {
            qparams.next = state.url;
            this.router.navigate([environment.loginRoute], {
              queryParams: qparams,
            });
            return false;
          }
        },
        (err) => {
          qparams.next = state.url;
          this.router.navigate([environment.loginRoute], {
            queryParams: qparams,
          });
          return false;
        }
      ));
    } else {
      qparams.next = state.url;
      this.router.navigate([environment.loginRoute], { queryParams: qparams });
      return false;
    }
  }
}
